export default "__VITE_ASSET__2cZUXZyV__"